module.exports = __webpack_public_path__ + "7bd8871b.svg";